import { getAllTemplates } from '@/src/request/common';
import { useRequest } from 'ahooks';
import { get } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';
import {
  OriCheckbox,
  SectionCollapse,
  SizeFittingTable,
} from 'src/components/Antd';
import { TableSelect } from 'src/components/EditableTable/TableForm1';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { ICategory } from 'src/types/common/template';
import css from './css.module.less';
//import Select from 'src/components/Antd/Select/OriginalSelect';
import { Icon } from '@/src/tools/icon';
import { ChannelType } from '@/src/types/common/SalesChannel';
import { Link } from 'react-router-dom';
import Select from 'src/components/Antd/Select/OriginalSelect';
import { EditIcon } from 'src/components/EditableTable/EditableTable';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const VirtualStock = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    products,
    logistics,
    onLogisticNotifyChange,
    onLogisticEmailChange,
    onLogisticSmsChange,
    disabled,
  } = props;
  const salesChannelType = useSalesChannelType();
  const { saleChannelUuid } = useParams() as any;
  const { data: { emailTemplates = [], smsTemplates = [] } = {} } = useRequest(
    () => getAllTemplates(ICategory.GiftCardIssued, saleChannelUuid),
  );

  //console.log('logistics', logistics);
  const col = [
    {
      width: 32,
      default: true,
      title: '',
      key: 'index',
      childGenerate: (_, __, index: number) => index + 1,
    },
    {
      title: getI18n('general.storeCommunicationSetting.product'),
      dataIndex: 'Product',
      default: true,
      optional: true,
      key: 'Product',
      //className: css.columnClass,
      minWidth: 280,
      childGenerate: (text, record, index) => {
        const { name, sku } = record;
        const display = name + ' ' + sku;
        return (
          <div className={css.nameContainer}>
            <NoWrapContainer>
              <GlobalTooltip title={display}>{display}</GlobalTooltip>
            </NoWrapContainer>
          </div>
        );
      },
    },
    {
      title: getI18n('general.productType'),
      dataIndex: 'type',
      default: true,
      optional: true,
      key: 'type',
      //className: css.columnClass,
      minWidth: 104,
      childGenerate: (text, record, index) => {
        const { productType } = record;
        const dict = {
          GiftCard: getI18n('general.giftCard'),
          Service: getI18n('general.service'),
        };
        return dict[productType] || '';
      },
    },
    {
      title: (
        <div>
          {!disabled && <EditIcon />}
          {getI18n('general.notifyCustomer')}
        </div>
      ),
      dataIndex: 'notify',
      default: true,
      optional: true,
      key: 'notify',
      //className: css.columnClass,
      minWidth: 160,
      childGenerate: (text, record, index) => {
        const { uuid, productType } = record;
        const notify = get(logistics[uuid], 'notify');
        return (
          <OriCheckbox
            disabled={productType === 'GiftCard' || disabled}
            checked={notify}
            onChange={(e) => {
              onLogisticNotifyChange(uuid, e.target.checked);
            }}>
            {notify ? getI18n('general.enabled') : getI18n('general.disabled')}
          </OriCheckbox>
        );
      },
    },
    {
      title: (
        <div>
          {!disabled && <EditIcon />}
          {getI18n('salesChannelProductDetail.index.emailTemplate')}
        </div>
      ),
      dataIndex: 'type',
      default: true,
      optional: true,
      key: 'type',
      //className: css.columnClass,
      minWidth: 176,
      childGenerate: (text, record, index) => {
        const { uuid } = record;
        const emailTemplateUuid = get(logistics, `${uuid}.emailTemplateUuid`);

        const selected = emailTemplates.find(
          (i) => i.uuid === emailTemplateUuid,
        );

        const label =
          get(selected, 'name') ||
          getI18n('salesChannelProductDetail.index.noAutofill');

        //const label = emailTemplateUuid ? emailTemplateUuid.find(): 'No Autofill';
        return (
          <TableSelect
            itemProps={{
              getPopupContainer: () => document.body,
            }}
            label={label}
            value={emailTemplateUuid}
            disabled={disabled}
            onChange={(e) => {
              onLogisticEmailChange(uuid, e);
              //   if (onAutoChange) {
              //     onAutoChange(code, e);
              //   }
              return;
            }}>
            <Select.Option value={null}>
              {getI18n('salesChannelProductDetail.index.noAutofill')}
            </Select.Option>
            {emailTemplates.map((i: any) => {
              return (
                <Select.Option value={i.uuid} key={i.uuid}>
                  {i.name}
                </Select.Option>
              );
            })}
          </TableSelect>
        );
      },
    },
    {
      title: (
        <div>
          {!disabled && <EditIcon />}
          {getI18n('salesChannelProductDetail.index.sMSTemplate')}
        </div>
      ),
      dataIndex: 'SMS',
      default: true,
      optional: true,
      key: 'SMS',
      //className: css.columnClass,
      minWidth: 176,
      childGenerate: (text, record, index) => {
        const { uuid } = record;
        const smsTemplateUuid = get(logistics, `${uuid}.smsTemplateUuid`);
        const selected = smsTemplates.find((i) => i.uuid === smsTemplateUuid);

        const label =
          get(selected, 'name') ||
          getI18n('salesChannelProductDetail.index.noAutofill');
        return (
          <TableSelect
            itemProps={{
              getPopupContainer: () => document.body,
            }}
            label={label}
            value={smsTemplateUuid}
            disabled={disabled}
            onChange={(e) => {
              onLogisticSmsChange(uuid, e);
              return;
            }}>
            <Select.Option value={null}>
              {getI18n('salesChannelProductDetail.index.noAutofill')}
            </Select.Option>
            {smsTemplates.map((i: any) => {
              return (
                <Select.Option value={i.uuid} key={i.uuid}>
                  {i.name}
                </Select.Option>
              );
            })}
          </TableSelect>
        );
      },
    },
    ...(salesChannelType == ChannelType.MiniProgram
      ? [
          {
            title: (
              <div>
                {!disabled && <EditIcon />}
                {getI18n(
                  'salesChannelProductDetail.index.weChatNotificationTemplate',
                )}
              </div>
            ),
            dataIndex: 'SMS',
            default: true,
            optional: true,
            key: 'SMS',
            //className: css.columnClass,
            minWidth: 232,
            childGenerate: (text, record, index) => {
              const { uuid } = record;
              const wechatTemplateUuid = get(
                logistics[uuid],
                'wechatTemplateUuid',
              );
              return (
                <TableSelect
                  itemProps={{
                    getPopupContainer: () => document.body,
                  }}
                  label={'-'}
                  value={wechatTemplateUuid}
                  disabled={disabled}
                  onChange={(e) => {
                    return;
                  }}></TableSelect>
              );
            },
          },
        ]
      : []),
  ];
  const renderTitle = () => {
    return (
      <div className={css.title}>
        <div className={'collapseTitle'}>
          {getI18n(
            'salesChannelProductDetail.index.virtualProductLogisticMethod',
          )}
        </div>
      </div>
    );
  };
  const renderContent = () => {
    return (
      <React.Fragment>
        <div className={css.container}>
          <SizeFittingTable
            pagination={false}
            dataSource={products}
            id={`SalesChannelLinkProductLogisticMethod`}
            columns={col}
            rowKey={'uuid'}
          />
        </div>
        <div className={css.bottomContainer}> {renderBottom()}</div>
      </React.Fragment>
    );
  };
  const renderBottom = () => {
    return (
      <div className={css.bottom}>
        <Icon type='iconinfo' className={css.icon} />
        <span>
          {`${getI18n(
            'salesChannelProductDetail.index.templateeditedinStoreSettings',
          )} > `}
          <Link to={'/productsList'}>
            {getI18n('general.sider.communication')}
          </Link>
        </span>
      </div>
    );
  };
  return (
    <SectionCollapse
      open={true}
      id={'salesChannelLinkProductVirtualStockCollapse'}
      titleStyle={{ height: '64px' }}
      title={renderTitle()}
      content={renderContent()}
      openMargin={16}
    />
  );
};
export default VirtualStock;
